import { render, staticRenderFns } from "./ObligationsReport.vue?vue&type=template&id=430c16d0&"
import script from "./ObligationsReport.vue?vue&type=script&lang=js&"
export * from "./ObligationsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports